"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
function withCountriesApollo(Component) {
    return react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query Countries {\n      countries {\n        countries {\n          name\n          countryCode\n          subregions {\n            name\n            code\n          }\n        }\n      }\n    }\n  "], ["\n    query Countries {\n      countries {\n        countries {\n          name\n          countryCode\n          subregions {\n            name\n            code\n          }\n        }\n      }\n    }\n  "]))))(Component);
}
exports.withCountriesApollo = withCountriesApollo;
exports.default = withCountriesApollo;
var templateObject_1;
//# sourceMappingURL=with_countries_apollo.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/addresses/with_countries_apollo.js
// module id = giTp
// module chunks = 20 21 22